import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./login.css"; // Importa los estilos solo aquí

function Login({ setAuth }) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();

    const response = await fetch("https://mikalet.com/api/portfolio/login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user, password }),
    });

    const data = await response.json();
    console.log(data);
    if (data.success) {
      localStorage.setItem("loggedIn", "true"); // Guardamos la sesión
      setAuth(true); // Actualizamos el estado de autenticación
      history.push("/admin"); // Redirigir a la página de admin
    } else {
      setError(data.message);
    }
  };

  return (
    <div className="login-container">
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Usuario"
          value={user}
          onChange={(e) => setUser(e.target.value)}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Ingresar</button>
      </form>
      {error && <p className="error">{error}</p>}
    </div>
  );
}

export default Login;